"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocalPersistedIds = void 0;
var _react = require("react");
const useLocalPersistedIds = key => {
  const [selectedIds, setSelectedIds] = (0, _react.useState)(() => {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : [];
  });
  const syncWithStorage = (0, _react.useCallback)(newIds => {
    const uniqueIds = [...new Set(newIds)];
    localStorage.setItem(key, JSON.stringify(uniqueIds));
    setSelectedIds(uniqueIds);
  }, [key]);
  const addId = (0, _react.useCallback)(id => {
    if (!selectedIds.includes(id)) {
      syncWithStorage([...selectedIds, id]);
    }
  }, [selectedIds, syncWithStorage]);
  const removeId = (0, _react.useCallback)(id => {
    syncWithStorage(selectedIds.filter(item => item !== id));
  }, [selectedIds, syncWithStorage]);
  const idSet = (0, _react.useMemo)(() => new Set(selectedIds), [selectedIds]);
  const isSelected = (0, _react.useCallback)(id => idSet.has(id), [idSet]);
  return {
    selectedIds,
    addId,
    removeId,
    isSelected
  };
};
exports.useLocalPersistedIds = useLocalPersistedIds;